import React from 'react';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

export type FeedbackKind = 'success' | 'error' | 'info';

export interface Feedback {
  kind: FeedbackKind;
  message: string;
}

const kindStyles: Record<FeedbackKind, { box: string; icon: React.ComponentType<{ className?: string }> }> = {
  success: { box: 'border-primary/40 bg-primary/10 text-primary', icon: CheckCircleIcon },
  error: { box: 'border-red-500/40 bg-red-500/10 text-red-400', icon: ExclamationCircleIcon },
  info: { box: 'border-blue-500/40 bg-blue-500/10 text-blue-400', icon: InformationCircleIcon },
};

interface InlineFeedbackProps {
  feedback: Feedback | null;
  className?: string;
}

// Small in-place alert shown next to the control that triggered it.
export function InlineFeedback({ feedback, className = '' }: InlineFeedbackProps) {
  if (!feedback) return null;
  const { box, icon: Icon } = kindStyles[feedback.kind];
  return (
    <div
      role={feedback.kind === 'error' ? 'alert' : 'status'}
      className={`flex items-start gap-2 rounded-md border px-3 py-2 text-sm ${box} ${className}`}
    >
      <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <span className="whitespace-pre-wrap break-words">{feedback.message}</span>
    </div>
  );
}

export default InlineFeedback;
